













import Vue from 'vue'
import CCategoryNew from '~/components/shared/configurable/category/CCategoryNew.vue'
import { CategoryId } from '~/models/category/types'
export default Vue.extend({
  components: {
    CCategoryNew
  },
  data() {
    return {
      rootCategoryId: CategoryId.PARTS
    }
  },
  computed: {
    title(): string {
      return this.$i18n.t('free {type} classified', {
        type: `${this.$i18n.t('part::parts_new_page')}/${this.$i18n.t(
          'accessory'
        )}`
      })
    }
  },
  methods: {
    handleCategoryChange(suggestion: any) {
      if (
        this.rootCategoryId === suggestion.rootCategory &&
        this.$route.query?.cid !== suggestion.id
      ) {
        this.$router.replace({ query: { cid: suggestion.id } })
      }
    }
  }
})
